import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import MuxPlayer from '@mux/mux-player-react';
import { tvApi } from './TVContext';
import { useDpadNavigation } from './focus';

const TVPlayer = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'main';
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useDpadNavigation(() => navigate(`/tv/content/${id}`));

  useEffect(() => {
    const load = async () => {
      try {
        const res = await tvApi.get(`/content/${id}`);
        setContent(res.data);
      } catch (e) {
        setContent(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) return <div className="tv-root tv-loading" data-testid="tv-player-loading">Loading player…</div>;
  if (!content) return <div className="tv-root tv-loading">Content unavailable. Press Back.</div>;

  const playbackId = type === 'trailer' ? content.trailer_playback_id : (content.playback_id || content.mux_playback_id);

  if (!playbackId) {
    return (
      <div className="tv-root tv-loading" data-testid="tv-player-no-playback">
        Video not available. Press Back.
      </div>
    );
  }

  return (
    <div className="tv-root" style={{ background: '#000', padding: 0 }} data-testid="tv-player">
      <MuxPlayer
        playbackId={playbackId}
        autoPlay
        streamType="on-demand"
        style={{ width: '100vw', height: '100vh' }}
        primaryColor="#1FA2FF"
        accentColor="#1FA2FF"
        metadata={{
          video_title: content.title || content.name,
          video_id: content.id,
          player_name: 'Pulse Media TV',
        }}
      />
    </div>
  );
};

export default TVPlayer;
